import { httpRequest } from '@common/util/api-common.util';

import { exibirModal } from '../../liberacao_total/store/liberacaoTotal.action';
import { showModal } from '@common/common.action';

export const FECHAR_MODAL = 'FECHAR_MODAL';
export const CONFIRMAR_LIBERACAO_PARCIAL = 'CONFIRMAR_LIBERACAO_PARCIAL';

export const fecharModal = (
  laudoLiberadoPacialmente,
  liberacaoParcialHabilitada,
  laudo
) => {
  if (!laudoLiberadoPacialmente && liberacaoParcialHabilitada) {
    return [
      {
        type: FECHAR_MODAL,
        payload: {
          laudo: laudo,
          modalAberto: true,
        },
      },
      showModal(true),
    ];
  } else if (!liberacaoParcialHabilitada || laudoLiberadoPacialmente) {
    return [
      {
        type: FECHAR_MODAL,
        payload: {

          laudo: laudo,
          modalAberto: false,
        },
      },
      showModal(true),
      exibirModal(),
    ];
  } else {
    return [
      {
        type: FECHAR_MODAL,
        payload: {
          laudo: laudo,
          modalAberto: false,
        },
      },
      showModal(false),
    ];
  }

  // if (laudoLiberadoPacialmente) {
  //   return [
  //     {
  //       type: FECHAR_MODAL,
  //       payload: {
  //         laudo: laudo,
  //         modalAberto: false,
  //       },
  //     },
  //     showModal(true),
  //     exibirModal(),
  //   ];
  // } else if (liberacaoParcialHabilitada) {
  //   return [
  //     {
  //       type: FECHAR_MODAL,
  //       payload: {
  //         laudo: laudo,
  //         modalAberto: true,
  //       },
  //     },
  //     showModal(true),
  //   ];
  // } else {
  //   showModal(false);
  // }
};

export const liberarLaudoParcialmente = () => {
  return (dispatch, getState) => {
    var state = getState();
    var laudo = state.modalLiberacaoParcial.laudo;
    var usuarioLogado = state.usuario.usuarioId;

    httpRequest(`laudos/${laudo}/liberacao-parcial`, 'POST', {
      usuarioLogado: usuarioLogado,
    }).then((resp) =>
      dispatch({ type: CONFIRMAR_LIBERACAO_PARCIAL, payload: resp.data })
    );
  };
};

export const OBTER_CONFIGURACAO = 'OBTER_CONFIGURACAO';
export const obterConfiguraco = async () => {
  return (dispatch) => {
    httpRequest(`configuracoes/liberacao-laudo`).then((resp) => {
      dispatch({ type: OBTER_CONFIGURACAO, payload: resp.data });
    });
  };
};



// WEBPACK FOOTER //
// ./src/pages/laudo/modais/liberacao_parcial/store/liberacao.action.js